import React from 'react';

import { SwitchCompanyMenu } from '@/console/features/switch-company/components/switch-company-menu/switch-company-menu';
import {
  ButtonContentWrapper,
  CompanyAvatar,
  CompanyName,
  CustomCollapse,
  SwitchCompanyButton,
} from '@/console/features/switch-company/switch-company.styled';
import { TSwitchCompanyProps } from '@/console/features/switch-company/switch-company.types';
import { MoreVertIcon } from '@/shared/assets/icons/more-vert-icon';
import { PopoverController } from '@/shared/components/ui/popover/components/popover-controller/popover-controller';
import {
  useReadTenantQuery,
  useReadTenantsForUserQuery,
} from '@/shared/redux/api/ident/ident-api';
import { BaseTenantFragment } from '@/shared/types/types.generated';
import { getAvatarLabel } from '@/shared/utils/avatar';

export const SwitchCompany: React.FC<TSwitchCompanyProps> = ({ expanded }) => {
  const { data } = useReadTenantQuery();
  const { data: tenantsData, isLoading } = useReadTenantsForUserQuery();

  const currentCompany: BaseTenantFragment = {
    tenantId: data?.readTenant?.tenantId!,
    companyName: data?.readTenant?.companyName!,
    owner: data?.readTenant?.owner!,
  };
  const additionalTenants: BaseTenantFragment[] =
    tenantsData?.readAdditionalTenantsForUser.items ?? [];
  const companies = [currentCompany, ...additionalTenants].sort((a, b) =>
    a.companyName.localeCompare(b.companyName),
  );

  return (
    <PopoverController
      trigger={
        <SwitchCompanyButton
          disabled={isLoading || companies.length <= 1}
          fullWidth={expanded}
          tooltip={currentCompany?.companyName}
          tooltipProps={{
            placement: 'right',
            arrow: true,
            disableHoverListener: expanded,
            noMaxWidth: true,
          }}
        >
          <ButtonContentWrapper>
            <CompanyAvatar variant="rounded">
              {getAvatarLabel(currentCompany.companyName)}
            </CompanyAvatar>
            <CustomCollapse in={expanded} orientation="horizontal">
              <CompanyName>{currentCompany.companyName}</CompanyName>
              {companies.length > 1 && <MoreVertIcon size="1rem" />}
            </CustomCollapse>
          </ButtonContentWrapper>
        </SwitchCompanyButton>
      }
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
    >
      {(popoverClose) => (
        <SwitchCompanyMenu onClose={popoverClose} companies={companies} />
      )}
    </PopoverController>
  );
};
